/*
* WordPress Dependencies
*/ 
import domReady from '@wordpress/dom-ready';
import { createRoot } from '@wordpress/element';

/*
* Internal Dependencies
*/ 
import './assets/css/dashboard.scss';
import App from "./App";
import Header from './components/template/Header';

domReady(() => {
	const dashboard = document.getElementById('rioDashboard');
	
	if (dashboard) {
	  const root1 = createRoot(dashboard);
	  root1.render(<App />);
	}
  
	const tables = document.getElementById('riovizual-table-entries');
	if (tables) {
	  const root2 = createRoot(tables);
	  root2.render(<Header />);
	}
});
